<template>
  <v-container :class="'main-container' + (showDesktopVersion ? '' : ' zero-padding')">
    <object-images-full-mobile
      v-if="showingMobileFullImages"
      :images="selectedObject.objectImages"
      :compact="true"
      :img-folder="'objectImages/large'"
    />
    <v-layout wrap
      :style="showingMobileFullImages ? 'display:none;' : ''"
    >
      <page-header v-if="showDesktopVersion" />
      <page-header-mobile v-else />
      <top-menu v-if="showDesktopVersion" />
      <left-menu v-if="!showDesktopVersion" />
      <right-menu v-if="!showDesktopVersion" />

      <!-- MOBILE -->

      <template v-if="!showDesktopVersion">
        <v-container v-if="showDesktopVersion || pageName !== 'object'"
          class="search-form-container"
        >
          <search-form />
        </v-container>
        <v-layout
          style="width: 100%; min-height: 1200px;"
          :class="showDesktopVersion ? 'mt-3' : ''"
        >
          <object-info
            v-if="!showBookNowForm && selectedObject && selectedObject._id"
            :object="selectedObject"
          />
          <my-loader v-else-if="!showBookNowForm" :spacing="150" />
          <booking-form
            v-else-if="showBookNowForm && selectedObject && selectedObject._id"
            :object="selectedObject"
          />
        </v-layout>
      </template>

      <!-- DESKTOP -->

      <v-flex xs12 v-else>
        <v-layout class="content-area" wrap>
          <div
            v-if="showDesktopVersion"
            class="left-col-wide"
            id="content-area"
            :style="showDesktopVersion
              ? 'width:calc(100% - 240px)'
              : ''"
          >
            <my-loader v-if="!selectedObject || !selectedObject._id" :spacing="150" />
            <object-info
              v-if="!showBookNowForm && selectedObject && selectedObject._id"
              :object="selectedObject"
            />
            <booking-form
              v-if="showBookNowForm && selectedObject && selectedObject._id"
              :object="selectedObject"
            />
          </div>
          <div class="right-col-sidebar"

            >
              <template v-if="!showBookNowForm">
                <booking-form
                  v-if="selectedObject && selectedObject._id"
                  :object="selectedObject"
                  :sidebar="true"
                />
                <div>
                  <contact-us-menu
                    :sidebar="true"
                    :contact-options="contactOptions"
                  />
                </div>
                <div v-if="selectedObject && selectedObject._id">
                  <calendar-legend
                    :show-legend-at-the-top="true"
                  />
                  <calendar-navigation
                    :show-overlay="!selectedObject.calendar"
                  />
                  <calendar-navigation
                    v-if="showDesktopVersion && selectedObject.calendar"
                    :plus-months="1" :show-legend="false"
                    :show-overlay="!selectedObject.calendar"
                  />
                  <calendar-navigation
                    v-if="showDesktopVersion && selectedObject.calendar"
                    :plus-months="2" :show-legend="false"
                    :show-overlay="!selectedObject.calendar"
                  />
                  <calendar-navigation
                    v-if="showDesktopVersion && selectedObject.calendar"
                    :plus-months="3" :show-legend="false"
                    :show-overlay="!selectedObject.calendar"
                  />
                  <calendar-navigation
                    v-if="showDesktopVersion && selectedObject.calendar"
                    :plus-months="4" :show-legend="false"
                    :show-overlay="!selectedObject.calendar"
                  />
                  <calendar-navigation
                    v-if="showDesktopVersion && selectedObject.calendar"
                    :plus-months="5"
                    :show-legend="false"
                    :show-overlay="!selectedObject.calendar"
                  />
                </div>
              </template>
              <contact-banner />
          </div>
        </v-layout>
      </v-flex>
      <page-footer />
    </v-layout>
  </v-container>
</template>

<script>
import sharedComputed from './sharedComputed'
import ContactUsMenu from './../components/_ContactUsMenu'
import BookingForm from './../components/BookingForm'
import sharedMethods from './../methods/sharedMethods'
import ObjectImagesFullMobile from './../components/ObjectImagesFullMobile'
import MyLoader from './../components/_MyLoader'
import api from './../api'
import ObjectInfo from './../components/ObjectInfo'
import PageHeader from './../components/_PageHeader'
import PageHeaderMobile from './../components/_PageHeaderMobile'
import PageFooter from './../components/_PageFooter'
import FacebookFrame from './../components/_FacebookFrame'
import Banners from './../components/_Banners'
import ContactBanner from './../components/_ContactBanner'
import MainShare from './../components/_MainShare'
import SearchForm from './../components/SearchForm'
import TopMenu from './../components/TopMenu'
import LeftMenu from './../components/LeftMenu'
import RightMenu from './../components/RightMenu'
import CalendarNavigation from './../components/CalendarNavigation'
import CalendarLegend from './../components/CalendarLegend'
import { createHelpers } from 'vuex-map-fields'
import state from './../state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'Object',

  metaInfo () {
    return this.getMetaTags()
  },

  props: {
    id: {
      type: String,
      default: null
    }
  },

  components: {
    PageHeader,
    PageHeaderMobile,
    PageFooter,
    SearchForm,
    TopMenu,
    LeftMenu,
    RightMenu,
    CalendarNavigation,
    ObjectInfo,
    FacebookFrame,
    MainShare,
    Banners,
    ContactBanner,
    MyLoader,
    ObjectImagesFullMobile,
    BookingForm,
    ContactUsMenu,
    CalendarLegend
  },

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedComputed,

    datePeriodComputed () {
      return this.searchFilters.dateStart + '_' + this.searchFilters.dateEnd
    },

    pageName () {
      return this.$route.name
    },

    showingMobileFullImages () {
      return !this.showDesktopVersion && this.showingFullImage &&
        this.selectedObject.objectImages && this.selectedObject.objectImages.length > 0
    }
  },

  watch: {
    datePeriodComputed (value) {
      if (this.searchFilters.dateStart && this.searchFilters.dateEnd) {
        this.getObjectPrice()
      } else {
        this.resetPrice()
      }
    },

    id (value) {
      if (value) {
        this.selectedObject = {}
        this.getObjectInfo().then(() => {
          this.getObjectPrice()
        })
      }
    }
  },

  created () {
    // this.showBookNowForm = false
    this.selectedObject = {}
    if (this.id) {
      this.progressOpening = true
      this.getObjectInfo().then(() => {
        this.getObjectPrice()
      })
      window.scrollTo(0, 0)
    }
    this.setContentAreaWidth()
  },

  methods: {
    ...sharedMethods,

    getObjectInfo () {
      return new Promise(resolve => {
        let filters = []
        // NOTE - no need for dates any more as getObjectPrice is sent after anyway
        // if (this.searchFilters.dateStart && this.searchFilters.dateEnd) {
        //   filters.push({
        //     key: 'dateStart',
        //     value: this.formatYMD(this.searchFilters.dateStart)
        //   })
        //   filters.push({
        //     key: 'dateEnd',
        //     value: this.formatYMD(this.searchFilters.dateEnd)
        //   })
        // }
        return api.getOneItemWithQuery('objects', this.id, filters).then(result => {
          // Sort images
          result.objectImages = result.objectImages.sort((a, b) => (
            parseInt(a.sortOrder) > parseInt(b.sortOrder) ? 1 : -1
          ))
          this.selectedObject = result
          this.progressOpening = false
          this.metaTitle = this.selectedObject.objectName + ', ' + this.selectedObject.address
          this.metaUrl = this.objectFullLink(this.selectedObject)
          this.metaDescription = this.getObjectDescription(this.selectedObject)
          this.metaImage = this.getObjectFistImagePreviewFullLink(this.selectedObject)
          resolve(true)
        })
      })
    }
  }
}
</script>
